import { ConfigService } from '@maia/config';
import { BaseService } from '@maia/feature-utils';
import { HttpService } from '@maia/httpClient';
import { IInsuranceDocuments, IInsuranceEntity } from '../../shared';
import { IProductListEntity } from '../../entitites/product-list.entity';

export class InsuranceService extends BaseService {
  constructor(httpService: HttpService, configService: ConfigService) {
    super(httpService, configService);
  }

  public async findMany(path: string, search: Record<string, unknown>) {
    const response = await this.getMany<IInsuranceEntity>(
      path,
      search,
      'insurances',
    );
    return response;
  }

  public async find(path: string) {
    const res = await this.get<Array<IInsuranceEntity>>(path, 'insurance');
    return Array.isArray(res) ? res[0] : res;
  }

  public async getDocuments({ insuranceGuid }: { insuranceGuid: string }) {
    return await this.get<IInsuranceDocuments>(
      `insurances/${insuranceGuid}/documents`,
      'Get insurance documents',
    );
  }

  public async getFilterProducts() {
    return await this.get<IProductListEntity>(
      `data/products`,
      'Get filter products',
    );
  }
}
